import { render, staticRenderFns } from "./faceRecognition.vue?vue&type=template&id=3d53060a&scoped=true"
import script from "./faceRecognition.vue?vue&type=script&lang=js"
export * from "./faceRecognition.vue?vue&type=script&lang=js"
import style0 from "./faceRecognition.vue?vue&type=style&index=0&id=3d53060a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d53060a",
  null
  
)

export default component.exports